import React from 'react'

const SpecialIndentRequest = () => {
  return (
    <div>
      This is Special Indent Request.
    </div>
  )
}

export default SpecialIndentRequest
